export const PopularSearches = [
    "Metformin",
    "Viagra",
    "Cialis",
    "Amoxicillin",
    "Lisinopril",
    "Gabapentin",
    "Losartan",
    "Azithromycin",
    "Sildenafil",
    "Tadalafil",
    "Doxycycline",
    "Finasteride",
    "Ivermectin",
    "Sertraline",
    "Fluoxetine",
    "Montelukast",
    "Rosuvastatin",
    "Tramadol",
    "Bupropion",
    "Hydroxychloroquine",
    "Acyclovir",
    "Anastrozole",
    "Cabergoline",
    "Ceftriaxone",
    "Clomiphene",
    "Dapagliflozin",
    "Domperidone",
    "Dutasteride",
    "Enclomiphene",
    "Estradiol",
    "Exemestane",
    "Ezetimibe",
    "Fenbendazole",
    "Fluconazole",
    "Fluvoxamine",
    "Frusemide",
    "Hcg",
    "Isotretinoin",
    "Itraconazole",
    "Ketoconazole",
    "Letrozole",
    "Levofloxacin",
    "Minoxidil",
    "Mirtazapine",
    "Modafinil",
    "Molnupiravir",
    "Naltrexone",
    "Nebivolol",
    "Olmesartan",
    "Oseltamivir",
    "Oxandrolone",
    "Paroxetine",
    "Pramipexole",
    "Prednisolone",
    "Pregabalin",
    "Progesterone",
    "Prometrium",
    "Propranolol",
    "Raloxifene",
    "Salbutamol",
    "Semaglutide",
    "Sitagliptin",
    "Spironolactone",
    "Tamoxifen",
    "Tamsulosin",
    "Telmisartan",
    "Tenofovir",
    "Terbinafine",
    "Testosterone Enanthate",
    "Tetracycline",
    "Thyroxine",
    "Tofisopam",
    "Torasemide",
    "Trenbolone",
    "Tretinoin",
    "Valacyclovir",
    "Vardenafil",
    "Zaleplon",
    "Zopiclone"
];

export const Ingredients = [
    "Metformin",
    "Atorvastatin",
    "Levothyroxine",
    "Lisinopril",
    "Amlodipine",
    "Metoprolol",
    "Omeprazole",
    "Simvastatin",
    "Losartan",
    "Albuterol",
    "Gabapentin",
    "Hydrochlorothiazide",
    "Sertraline",
    "Acetaminophen",
    "Ibuprofen",
    "Amoxicillin",
    "Fluoxetine",
    "Escitalopram",
    "Azithromycin",
    "Montelukast",
    "Rosuvastatin",
    "Pantoprazole",
    "Furosemide",
    "Trazodone",
    "Duloxetine",
    "Venlafaxine",
    "Warfarin",
    "Citalopram",
    "Prednisone",
    "Tramadol",
    "Bupropion",
    "Carvedilol",
    "Clopidogrel",
    "Meloxicam",
    "Alprazolam",
    "Cyclobenzaprine",
    "Pravastatin",
    "Clonazepam",
    "Insulin Glargine",
    "Valsartan",
    "Glipizide",
    "Aspirin",
    "Naproxen",
    "Lorazepam",
    "Doxycycline",
    "Sitagliptin",
    "Empagliflozin",
    "Semaglutide",
    "Tadalafil",
    "Sildenafil",
    "Finasteride",
    "Dutasteride",
    "Tamsulosin",
    "Pregabalin",
    "Quetiapine",
];

export const Manufacturers = [
    // Top tier - Major global/Indian pharmaceutical companies
    {
        name: "Sun Pharma",
        image: "https://upload.wikimedia.org/wikipedia/en/thumb/5/50/Sun_Pharma_logo.svg/1200px-Sun_Pharma_logo.svg.png",
        uri: "sun-pharmaceutical-industries",
    },
    {
        name: "Cipla",
        image: "https://www.cipla.com/themes/cipla/logo.svg",
        uri: "cipla",
    },
    {
        name: "Dr. Reddy's Laboratories",
        image: "https://www.drreddys.com/images/DrR_Logo_Primary_RGB.svg",
        uri: "dr-reddys",
    },
    {
        name: "Lupin",
        image: "https://logowik.com/content/uploads/images/lupin-limited8595.jpg",
        uri: "lupin-pharmaceuticals"
    },
    {
        name: "Mankind Pharma",
        image: "https://companieslogo.com/img/orig/MANKIND.NS-3f70896f.png?t=1720244492",
        uri: "mankind-pharma"
    },
    {
        name: "Zydus Lifesciences (Cadila)",
        image: "https://www.zyduslife.com/zyduslife/img/zydus_life_logo.jpg",
        uri: "zydus-cadila"
    },
    {
        name: "Torrent Pharmaceuticals",
        image: "https://cdn.healthtechalpha.com/static/corporatesById/18768.png",
        uri: "torrent-pharmaceuticals"
    },
    {
        name: "Aurobindo Pharma",
        image: "https://www.aurobindo.com/images/logo.webp",
        uri: "aurobindo"
    },
    {
        name: "Intas Pharmaceuticals",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMRfABl7EfMH-_orqjMRTDfr9LSdJpqfIXyw&s",
        uri: "intas-pharmaceuticals"
    },
    {
        name: "Alkem Laboratories",
        image: "https://www.alkemlabs.com/assets/images/logo.png",
        uri: "alkem-laboratories"
    },
    {
        name: "Glenmark",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQL2ElclL1_mvHxG3FDVYSSi-Qla5UC35mymw&s",
        uri: "glenmark-pharmaceuticals"
    },
    {
        name: "Wockhardt",
        image: "https://www.indianpharmapost.com/public/thumbs/news/2025/02/16740/WOCKHARDT.jpg",
        uri: "wockhardt"
    },
    // Second tier - Mid-sized pharmaceutical companies
    {
        name: "Ajanta Pharma",
        image: "https://www.ajantapharma.com/assets/frontend/images/new_small_logo.png",
        uri: "ajanta-pharma"
    },
    {
        name: "Strides Pharma",
        image: "https://www.strides.com/images/logo.jpg",
        uri: "strides-arcolab"
    },
    {
        name: "GlaxoSmithKline",
        image: "https://1000logos.net/wp-content/uploads/2023/03/GSK-logo.png",
        uri: "glaxosmithkline"
    },
    {
        name: "HAB Pharmaceuticals",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpsv9_zW2zyysI_y-MwCseWvDrfVR4_TUAVA&s",
        link: "https://habpharma.com"
    },
    {
        name: "Healing Pharma",
        image: "https://play-lh.googleusercontent.com/pONLlgUJLir-tLDLAEEVYBhWU83Wb1IiQ77qS_xp3pR8Jn61KA7s9_MI8XRolhqcftc",
        link: "https://www.healingpharma.in"
    },
    {
        name: "Sunrise Remedies",
        image: "https://sunriseremedies.in/wp-content/uploads/cropped-cropped-Sunrise-Remedies-Pvt.-Ltd..png",
        uri: "sunrise-remedies"
    },
    {
        name: "Centurion Laboratories",
        image: "https://5.imimg.com/data5/SELLER/Logo/2021/4/JO/FJ/ND/3800001/logo-90x90.jpg",
        link: "https://www.centurionlaboratories.com"
    },
    {
        name: "Fortune Healthcare",
        image: "https://img1.wsimg.com/isteam/ip/1c8c46bf-ccb8-4fdd-990a-32bae1d5ee27/logo_color.jpg/:/rs=h:199,cg:true,m/qt=q:100/ll",
        uri: "fortune-pharmacal"
    },
    {
        name: "Signature Pharmaceuticals",
        image: "https://www.signature-pharmaceutical.com/public/images/logo.png",
        uri: "signature-products"
    },
    {
        name: "Gebix Pharmaceuticals",
        image: "https://genixpharm.com/wp-content/uploads/2022/03/GENIX_LOGO_SQUARE_COLOR_SMALL_1024x1024.webp",
        link: "https://genixpharm.com"
    },
    {
        name: "Asher Pharmaceuticals",
        image: "https://www.asherpharmaceuticals.com/wp-content/uploads/2024/02/ASher-Logo@4x-1-png-120x98.webp",
        link: "https://www.asherpharmaceuticals.com"
    }
];

export const Sponsors = [
    {
        name: "Pharmacy Pilot",
        image: "https://pharmacypilot.info/favicon.ico",
        link: "https://pharmacypilot.info",
        description: "This platform is dedicated to creating a community where you can find reliable and accurate information about various pharmacy companies.",
        shortDescription: "Community platform for reliable pharmacy company information"
    },
    {
        name: "Ashvin Medicara",
        image: "https://i0.wp.com/ashvin.lk/wp-content/uploads/2024/09/Ashvin-MC-web-favicon.png",
        link: "http://ashvinmedicara.com",
        description: "Ashvin Medicara is committed to promoting health equity by educating the public about generic medications and advocating for affordable healthcare.",
        shortDescription: "Promoting health equity through generic medication education"
    },
    {
        name: "Pharmacy Checker Online",
        image: "https://pharmacycheckeronline.com/public/themes/_default/assets/images/pharmacy-checker-online-favicon.png",
        link: "https://pharmacycheckeronline.com",
        description: "Pharmacy Checker Online is a review site that provides information and verification on online pharmacies.",
        shortDescription: "Review and verification platform for online pharmacies"
    },
    {
        name: "LifesPharma",
        image: "https://lifespharma.com/wp-content/uploads/2024/07/Lifepharma_logo_final.png",
        link: "http://lifespharma.com",
        description: "Use this site for lawful purposes only and avoid actions that could harm the site or impair its functionality.",
        shortDescription: "Pharmaceutical platform for lawful use"
    },
    {
        name: "Pharmacy payment processing",
        image: "https://pharmacypaymentprocessing.com/wp-content/uploads/2023/05/cropped-PharmacyPaymentProcessing_icon-32x32.png",
        link: "http://pharmacypaymentprocessing.com",
        description: "Your one-stop-shop for online generic pharmacy payment processing and website development services!",
        shortDescription: "One-stop payment processing for online pharmacies"
    },
    {
        name: "Value Card Thailand",
        image: "https://valuecardthailand.com/favicon.ico",
        link: "http://valuecardthailand.com",
        description: " Offering you an easy, secure, and convenient way to purchase gift cards from top retailers and entertainment brands.",
        shortDescription: "Secure platform for purchasing gift cards"
    },
    {
        name: "Siam Escrow",
        image: "https://siamescrow.com/images/logo.png",
        link: "https://siamescrow.com",
        description: "Your Trusted Partner in Crypto and Non Crypto Escrow Services for Local and International Transactions",
        shortDescription: "Trusted escrow services for crypto and traditional transactions"
    },
];
/**
 * 
    {
        name: "Steroids and Bodybuilding",
        image: "https://steroidsandbodybuilding.com/wp-content/uploads/2024/04/Steroids-and-Bodybuilding-logo-135x135-1.png",
        link: "https://steroidsandbodybuilding.com",
        description: "Steroids and Bodybuilding is a website that provides information and resources for those interested in the use of steroids and bodybuilding.",
        shortDescription: "Information resource for steroids and bodybuilding"
    },
 */

export const ExampleSearchResults = [
    {
        title: "Aspirin pharmaceutical drugs and health products",
        description: "It is containing medications, Aspirin indications and usages ATC and ICD codes, combinations with other active ingredients and trade names information. It is containing medications, Aspirin indications and usages ATC and ICD codes, combinations with other active ingredients and trade names information. It is containing medications, Aspirin indications and usages ATC and ICD codes, combinations with other active ingredients and trade names information."
    },
    {
        title: "Acetylsalicylic Acid (Aspirin) - Drug Information",
        description: "Aspirin, also known as acetylsalicylic acid (ASA), is a medication used to reduce pain, fever, or inflammation."
    },
    {
        title: "Bayer Aspirin - Pain Reliever and Fever Reducer",
        description: "Bayer Aspirin is a pain reliever and fever reducer for adults. Learn about the benefits and safety information of Bayer Aspirin products."
    },
    {
        title: "Aspirin - Drug Information",
        description: "Aspirin, also known as acetylsalicylic acid (ASA), is a medication used to reduce pain, fever, or inflammation."
    },
    {
        title: "Low-Dose Aspirin Therapy for Cardiovascular Health",
        description: "Daily low-dose aspirin therapy may help prevent heart attacks and strokes in high-risk individuals. Learn about the benefits, risks, and recommended dosages."
    },
    {
        title: "Aspirin Side Effects and Safety Considerations",
        description: "Common side effects of aspirin include stomach irritation, bleeding, and allergic reactions. Learn about precautions, contraindications, and when to consult a healthcare provider."
    },
    {
        title: "Aspirin vs. Ibuprofen: Comparing OTC Pain Relievers",
        description: "Understand the differences between aspirin and ibuprofen, including their mechanisms of action, effectiveness for different conditions, and potential side effects."
    },
    {
        title: "Enteric-Coated Aspirin: Benefits and Limitations",
        description: "Enteric-coated aspirin is designed to reduce stomach irritation by dissolving in the intestines rather than the stomach. Learn about its advantages and when it's recommended."
    },
    {
        title: "Aspirin for Migraine Relief: Efficacy and Usage Guidelines",
        description: "Aspirin can be effective for treating migraines and tension headaches. Discover proper dosing, timing, and combination therapies for optimal relief."
    },
    {
        title: "Pediatric Use of Aspirin: Risks and Recommendations",
        description: "Aspirin is generally not recommended for children due to the risk of Reye's syndrome. Learn about age restrictions and safer alternatives for pediatric fever and pain."
    },
    {
        title: "Aspirin in Pregnancy: Safety Considerations and Guidelines",
        description: "Low-dose aspirin may be prescribed during pregnancy for specific conditions. Understand the risks, benefits, and current medical recommendations."
    },
    {
        title: "Aspirin for Primary Prevention: Changing Guidelines",
        description: "Recent changes in medical guidelines have altered recommendations for using aspirin to prevent first heart attacks. Learn about current advice based on age and risk factors."
    },
    {
        title: "Buffered Aspirin: Composition and Advantages",
        description: "Buffered aspirin contains ingredients that neutralize stomach acid. Discover how it differs from regular aspirin and when it might be preferred."
    },
    {
        title: "Aspirin Resistance: Causes, Detection, and Management",
        description: "Some individuals may not respond adequately to aspirin's antiplatelet effects. Learn about testing for aspirin resistance and alternative approaches."
    },
    {
        title: "Aspirin in Combination with Other Medications",
        description: "Aspirin is often combined with other drugs for enhanced effectiveness or reduced side effects. Explore common combinations and potential interactions."
    },
    {
        title: "History of Aspirin: From Willow Bark to Modern Medicine",
        description: "Trace the fascinating evolution of aspirin from its origins in ancient remedies to its development as one of the world's most widely used medications."
    },
    {
        title: "Aspirin for Cancer Prevention: Emerging Research",
        description: "Growing evidence suggests regular aspirin use may reduce the risk of certain cancers. Explore the latest findings and ongoing clinical trials."
    },
    {
        title: "Aspirin Dosage Forms: Tablets, Powders, and Extended-Release",
        description: "Aspirin comes in various formulations designed for different needs. Compare the absorption rates, duration of action, and specific uses of each form."
    },
    {
        title: "Aspirin Overdose: Symptoms, Treatment, and Prevention",
        description: "Recognize the signs of aspirin toxicity and learn about emergency interventions, long-term effects, and safe storage practices to prevent accidental overdose."
    },
    {
        title: "Generic vs. Brand-Name Aspirin: Differences and Similarities",
        description: "Compare the efficacy, safety, and cost considerations between generic aspirin products and brand-name versions like Bayer and Ecotrin."
    }
];

export const TradeNames = [
    { name: "Paracetamol", manufacturer: "Johnson & Johnson" },
    { name: "Amoxil", manufacturer: "GlaxoSmithKline" },
    { name: "Lipitor", manufacturer: "Pfizer" },
    { name: "Zoloft", manufacturer: "Pfizer" },
    { name: "Prozac", manufacturer: "Eli Lilly" },
    { name: "Nexium", manufacturer: "AstraZeneca" },
    { name: "Advil", manufacturer: "Pfizer Consumer Healthcare Division" },
    { name: "Tylenol", manufacturer: "McNeil Consumer Healthcare, a subsidiary of Johnson & Johnson" },
    { name: "Crestor", manufacturer: "AstraZeneca" },
    { name: "Viagra", manufacturer: "Pfizer" },
    { name: "Cialis", manufacturer: "Eli Lilly" },
    { name: "Lexapro", manufacturer: "Forest Laboratories, now part of Allergan plc" },
    { name: "Synthroid", manufacturer: "AbbVie" },
    { name: "Lyrica", manufacturer: "Upjohn, a division of Pfizer Inc." },
    { name: "Xanax", manufacturer: "Pfizer" },
    { name: "Adderall", manufacturer: "Teva" },
    { name: "Ambien", manufacturer: "Sanofi-Aventis" },
    { name: "Cymbalta", manufacturer: "Eli Lilly and Company International Corporation" },
    { name: "Humira", manufacturer: "AbbVie" },
    { name: "Abilify", manufacturer: "Otsuka Pharmaceutical Co., Ltd." }
];
